import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { VOICE_PROFILES_UI_ENABLED } from '@utils/constants/app-constants.ts';
import { VOICE_PROFILE_URL } from '@utils/api/endpoints.voice-profiles.ts';
import { VoiceProfileCapabilities } from '@utils/types/organization/voice-profile.ts';
import { VOICE_PROFILE_QUERY_KEYS } from './query-keys.ts';

/** Deployment readiness and caller permissions for every organization.
 * Enrollment additionally needs an administrator. The response carries no
 * keys, model paths or threshold values, so it is safe to hold in the cache.
 * Failed readiness requests leave enrollment and recognition unavailable. */
export const useVoiceProfileCapabilities = (enabled = true) =>
  useQuery<VoiceProfileCapabilities>(
    VOICE_PROFILE_QUERY_KEYS.capabilities(),
    async () => {
      const { data } = await Axios.get<VoiceProfileCapabilities>(
        VOICE_PROFILE_URL.capabilities()
      );
      return data;
    },
    {
      enabled: enabled && VOICE_PROFILES_UI_ENABLED,
      // Readiness changes when an operator reconfigures the deployment.
      staleTime: 5 * 60 * 1000,
      // A 403/404 here means "not available to you", which is an answer, not a
      // transient fault worth three retries.
      retry: false,
      useErrorBoundary: false
    }
  );
